export interface Option<T> {
	value: T;
	text: string;
	style?: string;
	legendaClass?: string;
}

export class Option<T> {
	constructor(
		public value: T,
		public text: string = `${value}`,
		public style?: string,
		public legendaClass?: string
	) {}
}

export const DEFAULT_EMPTY_STATE = 'Geen resultaten';
